var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortofentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg{fill:#e6007e}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-408ZM156-200 82-457q-4-12 1.5-23.5T101-496l59-20v-224q0-25 17.5-42t42.5-18h150v-120h220v120h150q24.75 0 42.375 17.625T800-740v225l60 19q11 4 16.5 15t1.5 23l-74 258q-48-5-89.5-29T641-286q-32 36-72.685 61-40.684 25-88.315 25t-88.315-25Q351-250 319-286q-32 33-73.5 57T156-200ZM80-40v-60h80q42 0 83-13t77-37q36 24 77 36t83 12q42 0 83-12t77-36q36 24 77 37t83 13h80v60h-80q-41 0-81-10.5T640-81q-39 20-80 30.5T480-40q-39 0-80-10.5T320-81q-39 20-78.802 30.5Q201.396-40 159.604-40H80Zm140-495 260-84 260 85v-206H220v205Zm259.5 275q51.5 0 91.5-41t69-76q25 30 55.5 58.5T762-269l51-179-333-108-334 108 52 177q35-19 66.5-47.5T320-377q30 36 69 76.5t90.5 40.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortofentry);
export default __webpack_public_path__ + "static/media/portofentry.6cac817850a2536164855338c2e7b063.svg";
export { ForwardRef as ReactComponent };